import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import {
  IRequest,
  IRequestItem,
  IRequestFilters,
  IRequestCostCenter,
  IRequestWorkOrderIONumber,
} from 'src/models/request.model';
import { IChangeLog } from 'src/models/change-log.model';
import services from 'src/services/request.service';
import fileServices from 'src/services/file.service';
import emailService from 'src/services/email.service';
import { formatRequestData } from 'src/selectors/request.selector';
import changeLogService from 'src/services/change-log.service';
import { RequestStatus } from 'src/constants';
import cndService from 'src/services/cnd-api.service';

export const actionTypes = {
  REQUEST_DATA_FETCH: 'REQUEST_DATA_FETCH',
  REQUEST_LIST_FETCH: 'REQUEST_LIST_FETCH',
  REQUEST_LIST_FETCH_DOWNLOAD: 'REQUEST_LIST_FETCH_DOWNLOAD',
  REQUEST_FETCH_FILTERS: 'REQUEST_FETCH_FILTERS',
  REQUEST_CREATE_PATROL_PASSENGER_DATA: 'REQUEST_CREATE_PATROL_PASSENGER_DATA',
  REQUEST_UPDATE_PATROL_PASSENGER_DATA: 'REQUEST_UPDATE_PATROL_PASSENGER_DATA',

  REQUEST_CREATE_PATROL_PASSENGER_CONTRACTOR_DATA:
    'REQUEST_CREATE_PATROL_PASSENGER_CONTRACTOR_DATA',
  REQUEST_UPDATE_PATROL_PASSENGER_CONTRACTOR_DATA:
    'REQUEST_UPDATE_PATROL_PASSENGER_CONTRACTOR_DATA',

  REQUEST_CREATE_CONSTRUCTION_DATA: 'REQUEST_CREATE_CONSTRUCTION_DATA',
  REQUEST_UPDATE_CONSTRUCTION_DATA: 'REQUEST_UPDATE_CONSTRUCTION_DATA',

  REQUEST_CREATE_CONSTRUCTION_CONTRACTOR_DATA:
    'REQUEST_CREATE_CONSTRUCTION_CONTRACTOR_DATA',
  REQUEST_UPDATE_CONSTRUCTION_CONTRACTOR_DATA:
    'REQUEST_UPDATE_CONSTRUCTION_CONTRACTOR_DATA',

  REQUEST_CREATE_DRONE_INTERNAL_DATA: 'REQUEST_CREATE_DRONE_INTERNAL_DATA',
  REQUEST_UPDATE_DRONE_INTERNAL_DATA: 'REQUEST_UPDATE_DRONE_INTERNAL_DATA',

  REQUEST_CREATE_DRONE_EXTERNAL_DATA: 'REQUEST_CREATE_DRONE_EXTERNAL_DATA',
  REQUEST_UPDATE_DRONE_EXTERNAL_DATA: 'REQUEST_UPDATE_DRONE_EXTERNAL_DATA',
  REQUEST_CNDAPI_DRONE_API_DATA: 'REQUEST_CNDAPI_DRONE_API_DATA',
  REQUEST_CNDAPI_CALL_AUDIT_CREATE: 'REQUEST_CNDAPI_CALL_AUDIT_CREATE',

  REQUEST_SET_DATA: 'REQUEST_SET_DATA',
  REQUEST_SET_PREVIEW: 'REQUEST_SET_PREVIEW',
  REQUEST_CULTURAL_FILE_UPLOAD: 'REQUEST_CULTURAL_FILE_UPLOAD',
  REQUEST_CULTURAL_FILE_DELETE: 'REQUEST_CULTURAL_FILE_DELETE',
  REQUEST_VERIFY_COST_CENTER: 'REQUEST_VERIFY_COST_CENTER',
  REQUEST_VERIFY_WORK_ORDER: 'REQUEST_VERIFY_WORK_ORDER',
  REQUEST_VERIFY_IO_NUMBER: 'REQUEST_VERIFY_IO_NUMBER',
  REQUEST_SEND_EMAIL: 'REQUEST_SEND_EMAIL',
  REQUEST_CHANGE_LOG_FETCH: 'REQUEST_CHANGE_LOG_FETCH',

  REQUEST_UPDATE_STATUS: 'REQUEST_UPDATE_STATUS',
  REQUEST_UPDATE_COST: 'REQUEST_UPDATE_COST',
  REQUEST_SET_COST: 'REQUEST_SET_COST',
  REQUEST_SET_LIST_PATH: 'REQUEST_SET_LIST_PATH',
} as const;

// This is where we put the actions that have promise/async payload like HTTP request
export const asyncActions = {
  filterGET: {
    type: actionTypes.REQUEST_FETCH_FILTERS,
    service: services.filterGET,
  },
  dataGET: {
    type: actionTypes.REQUEST_DATA_FETCH,
    service: services.dataGET,
  },
  listGET: {
    type: actionTypes.REQUEST_LIST_FETCH,
    service: services.listGET,
  },
  listGETDownload: {
    type: actionTypes.REQUEST_LIST_FETCH_DOWNLOAD,
    service: services.listGET,
  },
  createPatrolPassengerPOST: {
    type: actionTypes.REQUEST_CREATE_PATROL_PASSENGER_DATA,
    service: services.createPatrolPassengerPOST,
  },
  createPatrolPassengerContractorPOST: {
    type: actionTypes.REQUEST_CREATE_PATROL_PASSENGER_CONTRACTOR_DATA,
    service: services.createPatrolPassengerContractorPOST,
  },
  createConstructionPOST: {
    type: actionTypes.REQUEST_CREATE_CONSTRUCTION_DATA,
    service: services.createConstructionPOST,
  },
  updateConstructionPUT: {
    type: actionTypes.REQUEST_UPDATE_CONSTRUCTION_DATA,
    service: services.updateConstructionPUT,
    meta: { error: false },
  },
  createConstructionContractorPOST: {
    type: actionTypes.REQUEST_CREATE_CONSTRUCTION_CONTRACTOR_DATA,
    service: services.createConstructionContractorPOST,
  },
  updateConstructionContractorPUT: {
    type: actionTypes.REQUEST_UPDATE_CONSTRUCTION_CONTRACTOR_DATA,
    service: services.updateConstructionContractorPUT,
    meta: { error: false },
  },
  updatePatrolPassengerPUT: {
    type: actionTypes.REQUEST_UPDATE_PATROL_PASSENGER_DATA,
    service: services.updatePatrolPassengerPUT,
    meta: { error: false },
  },
  updatePatrolPassengerContractorPUT: {
    type: actionTypes.REQUEST_UPDATE_PATROL_PASSENGER_CONTRACTOR_DATA,
    service: services.updatePatrolPassengerContractorPUT,
    meta: { error: false },
  },
  uploadPOST: {
    type: actionTypes.REQUEST_CULTURAL_FILE_UPLOAD,
    service: fileServices.uploadPOST,
  },
  uploadDELETE: {
    type: actionTypes.REQUEST_CULTURAL_FILE_DELETE,
    service: fileServices.uploadDELETE,
  },
  verifyCostCenterGET: {
    type: actionTypes.REQUEST_VERIFY_COST_CENTER,
    service: services.verifyCostCenterGET,
  },
  verifyWorkOrderGET: {
    type: actionTypes.REQUEST_VERIFY_WORK_ORDER,
    service: services.verifyWorkOrderGET,
  },
  verifyIONumberGET: {
    type: actionTypes.REQUEST_VERIFY_IO_NUMBER,
    service: services.verifyIONumberGET,
  },
  createDroneInternalPOST: {
    type: actionTypes.REQUEST_CREATE_DRONE_INTERNAL_DATA,
    service: services.createDroneInternalPOST,
  },
  createDroneExternalPOST: {
    type: actionTypes.REQUEST_CREATE_DRONE_EXTERNAL_DATA,
    service: services.createDroneExternalPOST,
  },
  updateDroneInternalPUT: {
    type: actionTypes.REQUEST_UPDATE_DRONE_INTERNAL_DATA,
    service: services.updateDroneInternalPUT,
    meta: { error: false },
  },
  updateDroneExternalPUT: {
    type: actionTypes.REQUEST_UPDATE_DRONE_EXTERNAL_DATA,
    service: services.updateDroneExternalPUT,
    meta: { error: false },
  },
  CallCNDApi: {
    type: actionTypes.REQUEST_CNDAPI_DRONE_API_DATA,
    service: cndService.CallCNDApi,
  },
  CreateCNDAPIAuditCallDetails: {
    type: actionTypes.REQUEST_CNDAPI_CALL_AUDIT_CREATE,
    service: cndService.CreateCNDAPIAuditCallDetailsPOST,
  },
  sendEmailNotificationPOST: {
    type: actionTypes.REQUEST_SEND_EMAIL,
    service: emailService.sendEmailNotificationPOST,
  },
  changeLogGET: {
    type: actionTypes.REQUEST_CHANGE_LOG_FETCH,
    service: changeLogService.changeLogGET,
  },
  updateStatusPUT: {
    type: actionTypes.REQUEST_UPDATE_STATUS,
    service: services.updateStatusPUT,
  },
  updateFlightCostPUT: {
    type: actionTypes.REQUEST_UPDATE_COST,
    service: services.updateFlightCostPUT,
  },
};

export type IRequestAsync = typeof asyncActions;

export const syncActions = {
  setRequestData: (data?: IRequest) => ({
    type: actionTypes.REQUEST_SET_DATA,
    payload: data,
  }),
  setPreview: (isPreview: boolean) => ({
    type: actionTypes.REQUEST_SET_PREVIEW,
    payload: isPreview,
  }),
  setRequestCost: (
    requestId: number,
    flightCost: string,
    requestStatus: RequestStatus
  ) => ({
    type: actionTypes.REQUEST_SET_COST,
    payload: {
      requestId,
      flightCost,
      requestStatus,
    },
  }),
  setListPath: (payload?: string) => ({
    type: actionTypes.REQUEST_SET_LIST_PATH,
    payload,
  }),
};

export type IRequestSync = typeof syncActions;

export interface IRequestState
  extends ICommonState<IRequestAsync & IRequestSync> {
  data?: any;
  list: IRequestItem[];
  total: number;
  allTotal: number;
  passengerTotal: number;
  constructionTotal: number;
  droneTotal: number;
  preview: boolean;
  filters: IRequestFilters;
  costCenter?: IRequestCostCenter;
  validNumber?: IRequestWorkOrderIONumber;
  changeLog: IChangeLog[];
  logTotal: number;
  path?: string;
}

export const defaultState: IRequestState = {
  status: {},
  list: [],
  changeLog: [],
  logTotal: 0,
  total: 0,
  allTotal: 0,
  passengerTotal: 0,
  constructionTotal: 0,
  droneTotal: 0,
  preview: false,
  filters: {},
};

const RequestReducer = (
  state: IRequestState = defaultState,
  action: IReducerAction<IRequestAsync & IRequestSync>
): IRequestState => {
  switch (action.type) {
    case actionTypes.REQUEST_FETCH_FILTERS: {
      return {
        ...state,
        filters: action.payload ?? {},
      };
    }

    case actionTypes.REQUEST_LIST_FETCH: {
      return {
        ...state,
        list: action.payload?.rows ?? [],
        total: action.payload?.count.detected ?? 0,
        allTotal: action.payload?.count.all ?? 0,
        passengerTotal: action.payload?.count.passenger ?? 0,
        constructionTotal: action.payload?.count.construction ?? 0,
        droneTotal: action.payload?.count.drone ?? 0,
      };
    }

    case actionTypes.REQUEST_SET_DATA:
    case actionTypes.REQUEST_DATA_FETCH:
    case actionTypes.REQUEST_CREATE_CONSTRUCTION_DATA:
    case actionTypes.REQUEST_UPDATE_CONSTRUCTION_DATA:
    case actionTypes.REQUEST_CREATE_CONSTRUCTION_CONTRACTOR_DATA:
    case actionTypes.REQUEST_UPDATE_CONSTRUCTION_CONTRACTOR_DATA:
    case actionTypes.REQUEST_UPDATE_DRONE_INTERNAL_DATA:
    case actionTypes.REQUEST_CREATE_DRONE_INTERNAL_DATA: {
      return {
        ...state,
        data: formatRequestData(action.payload),
      };
    }

    case actionTypes.REQUEST_UPDATE_STATUS: {
      return {
        ...state,
        data: formatRequestData({
          ...state.data,
          request: {
            ...state.data?.request,
            ...action.payload,
          },
        } as IRequest),
      };
    }

    case actionTypes.REQUEST_SET_PREVIEW: {
      return {
        ...state,
        preview: action.payload ?? false,
      };
    }

    case actionTypes.REQUEST_VERIFY_COST_CENTER: {
      return {
        ...state,
        costCenter: action.payload,
      };
    }

    case actionTypes.REQUEST_VERIFY_WORK_ORDER:
    case actionTypes.REQUEST_VERIFY_IO_NUMBER: {
      return {
        ...state,
        validNumber: action.payload,
      };
    }

    case actionTypes.REQUEST_CHANGE_LOG_FETCH: {
      return {
        ...state,
        changeLog: action.payload?.changelog.rows ?? [],
        logTotal: action.payload?.changelog.count ?? 0,
      };
    }

    case actionTypes.REQUEST_SET_COST: {
      if (action.payload) {
        const { requestId, flightCost, requestStatus } = action.payload;

        return {
          ...state,
          list: state.list.reduce((items: IRequestItem[], item) => {
            const value = {
              ...item,
            };

            if (value.requestId === requestId) {
              value.flightCost = flightCost;
              value.requestStatus = requestStatus;
            }

            return [...items, value];
          }, []),
        };
      }

      return state;
    }

    case actionTypes.REQUEST_SET_LIST_PATH: {
      return {
        ...state,
        path: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default RequestReducer;
